import { render } from "./changeServe.vue?vue&type=template&id=1bf8fff4&scoped=true"
import script from "./changeServe.vue?vue&type=script&lang=js"
export * from "./changeServe.vue?vue&type=script&lang=js"

import "./changeServe.vue?vue&type=style&index=0&id=1bf8fff4&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf8fff4"]])

export default __exports__